import { CMSPersonProps } from "@types";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
    medicalExpert: CMSPersonProps;
    medicalExpertName: string;
};

export const MedicalExpertSchema = ({ medicalExpert, medicalExpertName }: Props): JSX.Element => {
    const { t } = useTranslation();
    const relatedTos = medicalExpert?.related_to
        ?.map(({ specialtyTitle }) => t(specialtyTitle))
        .filter((v) => v?.length > 0)
        .join(", ");

    const reviewedBy = {
        "@type": "Person",
        name: medicalExpertName,
        image: medicalExpert?.avatar_image?.url,
        knowsAbout: relatedTos,
        jobTitle: medicalExpert?.job_title,
    };

    const ldJson = {
        "@context": "http://schema.org",
        "@type": "WebPage",
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        reviewedBy: Object.fromEntries(Object.entries(reviewedBy).filter(([_, value]) => value)),
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson).replace("&quot;", `"`) }}
        />
    );
};
